import { endPoints } from 'api/';
import { CREATE_ORDER_SETTINGS } from 'actions/types';

/**
 * @description Creates setting object
 * @param Object payload
 * @returns Setting object
 */
export function createOrderSetting(payload) {
  /**
   * @param {Function} dispatch
   */
  return function (dispatch) {
    const action = {
      type: CREATE_ORDER_SETTINGS,
      /**
       * @param {Function} apiClient
       */
      request: async function (apiClient) {
        return await apiClient(endPoints.CREATE_ORDER_SETTINGS, payload);
      },
    };
    dispatch(action);
  };
}
